import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../common/Icon';
import { BaseText } from '../../common/BaseText';
import { Separator } from '../../common/Separator';
import { Comment } from '@models/Comments/CommentModel';
import { Touchable, TouchableTypeEnum } from '../../common/Touchable';
import { CommentList } from '@models/Comments/CommentListModel';

const Container = styled(Touchable)({
  flexDirection: 'row',
  alignItems: 'center',
});

const ActionText = styled(BaseText)({
  color: '$heading800',
  variant: 'text.medium',
});

export interface IExtendCommentTouchableProps {
  isExtended: boolean;
  onPress(): void;
  item: Comment;
}

export const ExtendCommentTouchable =
  observer<IExtendCommentTouchableProps>(
    ({ onPress, item, isExtended }) => {
      const { t } = useTranslation();
      const comments = item.comments as CommentList;

      const buttonIcon = isExtended
        ? 'small-arrow-up-light'
        : 'small-arrow-down-light';

      return (
        <Container onPress={onPress} type={TouchableTypeEnum.Opacity}>
          <Icon name={buttonIcon} size={20} />
          <Separator size="$5" vertical />
          <ActionText>
            {t('common.commentItem.answer', {
              count: comments.totalCount,
            })}
          </ActionText>
        </Container>
      );
    },
  );
